enum LikeAction {
  LIKE = 'like',
  RECOMMEND = 'recommend',
}

export default LikeAction;
